window.toolkit = window.toolkit || {};
const toolkit = window.toolkit;


export default {


    register(namespace, obj){
        
        if(toolkit[namespace]){
            console.warn(`Toolkit namespace ${namespace} already registered. Overwriting.`);
        }
        toolkit[namespace] = obj;

    }

}